import React from "react";
import Selectcustom from "./Selectcustom";
import tick from "../assets/tick.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {setSecondPage} from "../../store/addBusinessSlice";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorViewer from "../errorHandler/ErrorViewer";
function Address() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const nextpage = (value) => {
    dispatch(setSecondPage(
  { 
    streetNo: value.streetNo,
    cityZip: value.cityZip,
    cityOne: value.cityOne,
    cityTwo: value.cityTwo,
    state: value.state,}));
    navigate("/detail");
  };

  const validationSchema = Yup.object().shape({
    streetNo: Yup.string()
      .required("Street no is required"),
      cityZip: Yup.string()
      .required("City zip code is required"),
      cityOne: Yup.string()
      .required("City 1 is required"),
      cityTwo: Yup.string()
      .required("City 2 is required"),
      state: Yup.string()
      .required("State is required"),
   
  });
  let defaultValues = { streetNo: "",
  cityZip: "",
  cityOne: "",
  cityTwo: "",
  state: "", };
  const methods = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  return (
    <>
      <div
        className="d-flex align-items-center ps-3 pe-3 "
        style={{ height: "100vh", width: "100%" }}
      >
        <div className="container box_div" style={{ position: "relative" }}>
          <div className="steper_div">
            <div className="num">
              <img className="tick_img" src={tick} />
            </div>
            <div className="border_bottom_div"></div>
            <div className="num">
              <p>2</p>
            </div>
            <div className="border_bottom_div"></div>
            <div className="num2">
              <p>3</p>
            </div>
            <div className="border_bottom2_div"></div>
            <div className="num2">
              <p>4</p>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="card_business">
              <p className="business_heading1_main">Add Business Detail</p>
              <div>
                <p className="business_label mt-4">Street# / Name</p>
                {/* <Selectcustom placeholder={"Street# / Name"} /> */}
                <input
                  className="input1"
                  name="streetNo"
                  {...register("streetNo")}
                  
                  placeholder="Message Services"
                />
                {errors.streetNo && <ErrorViewer message={errors.streetNo.message} />}
                <p className="business_label">City Zip</p>
                {/* <Selectcustom placeholder={"City"} /> */}
                <input
                  className="input1"
                  name="cityZip"
                  {...register("cityZip")}
                
                  placeholder="Message Services"
                />
                {errors.cityZip && <ErrorViewer message={errors.cityZip.message} />}
                <div className="d-flex gap-2" style={{ width: "100%" }}>
                  <div style={{ width: "100%" }}>
                    <p className="business_label">
                      <span className="hysteric">*</span>City-1
                    </p>
                    {/* <Selectcustom placeholder={"City"} /> */}
                    <input
                      className="input1"
                      name="cityOne"
                      {...register("cityOne")}
                     
                      placeholder="Message Services"
                    />
                    {errors.cityOne && <ErrorViewer message={errors.cityOne.message} />}
                  </div>
                  <div style={{ width: "100%" }}>
                    <p className="business_label">City-2</p>
                    {/* <Selectcustom placeholder={"Zip"} /> */}
                    <input
                      className="input1"
                      name="cityTwo"
                      {...register("cityTwo")}
                      
                      placeholder="Message Services"
                    />
                    {errors.cityTwo && <ErrorViewer message={errors.cityTwo.message} />}
                  </div>
                </div>
                <p className="business_label">State</p>
                {/* <Selectcustom placeholder={"State"} /> */}
                <input
                  className="input1"
                  name="state"
                  {...register("state")}
                  
                  placeholder="Message Services"
                />
                {errors.state && <ErrorViewer message={errors.state.message} />}
                <button className="next_btn mb-4" onClick={handleSubmit(nextpage)}>
                  NEXT
                </button>
                <div className="bac_div">
                  <p className="back_text">Back</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Address;
